import {Injectable} from '@angular/core';
import {TeamService} from '@core/services/team.service';
import {Trainer, TrainerPositions} from '@shared/models/trainer';
import {Player, PlayerPosition} from '@shared/models/player';
import {group} from '@angular/animations';

interface ISquadObjectsGrouped<T> {
  position: string;
  objects: T[];
}

@Injectable({
  providedIn: 'root'
})
export class TeamSquadService {

  public squadPlayers: Player[];
  public squadPlayersGrouped: ISquadObjectsGrouped<Player>[];
  public squadTrainers: Trainer[];
  public squadTrainersGrouped: ISquadObjectsGrouped<Trainer>[];

  public loading = false;

  constructor( private teamService: TeamService ) { }

  public async getTrainers(): Promise<Trainer[]> {
    try {
      this.loading = !this.squadTrainers;
      this.squadTrainers = await this.teamService.fetchTeamTrainers(this.teamService.getCurrentTeamId());
      this.assignTrainerGroups();
      this.loading = false;
      return this.squadTrainers;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }

  public async getPlayers(): Promise<Player[]> {
    try {
      this.loading = !this.squadPlayers;
      this.squadPlayers = await this.teamService.fetchTeamSquad(this.teamService.getCurrentTeamId());
      this.assignPlayerGroups();
      this.loading = false;
      return this.squadPlayers;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }

  private assignTrainerGroups(): void {
    if (!this.squadTrainers) {
      return;
    }
    this.squadTrainersGrouped = [];
    TrainerPositions.forEach((pos) => {
      this.squadTrainersGrouped.push(
        { position: pos, objects: [] }
      )
    });
    this.squadTrainers.forEach((trainer) => {
      const index = TrainerPositions.indexOf(trainer.position);
      if (index > -1) {
        this.squadTrainersGrouped[index].objects.push(trainer);
      }
    });
  }

  private assignPlayerGroups(): void {
    if (!this.squadPlayers) {
      return;
    }
    this.squadPlayersGrouped = [];
    Object.values(PlayerPosition).forEach((pos) => {
      this.squadPlayersGrouped.push(
        { position: pos, objects: [] }
      )
    });
    const unknown = { position: 'Unbekannte Position', objects: [] };
    const positions = Object.values(PlayerPosition);
    this.squadPlayers.forEach((player) => {
      const index = positions.indexOf(player.position as PlayerPosition);
      if (index > -1) {
        this.squadPlayersGrouped[index].objects.push(player);
      } else {
        unknown.objects.push(player);
      }
    });
    this.squadPlayersGrouped.push(unknown);
  }
}
